import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddonService {
  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(form: any): any{
    return this.http.post(`${this.url}/addon/create`, form);
  }

  update(id: string, data: any): any{
    return this.http.put(`${this.url}/addon/update/${id}`, data)
  }

  delete(data: any): any{
    return this.http.post(`${this.url}/addon/delete`, data)
  }

  getAllByOrganization(filter: any): any {
    return this.http.get(`${this.url}/addons/organization`, {params: filter});
  }
}
